var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordValidationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 6.50019V9.83353M10.0001 13.1669H10.0085M8.84622 2.24329L1.99215 14.0821C1.61198 14.7388 1.42189 15.0671 1.44999 15.3366C1.47449 15.5716 1.59763 15.7852 1.78876 15.9242C2.0079 16.0835 2.38728 16.0835 3.14605 16.0835H16.8542C17.613 16.0835 17.9923 16.0835 18.2115 15.9242C18.4026 15.7852 18.5258 15.5716 18.5503 15.3366C18.5783 15.0671 18.3883 14.7388 18.0081 14.0821L11.154 2.24329C10.7752 1.58899 10.5858 1.26184 10.3387 1.15196C10.1232 1.05612 9.87709 1.05612 9.66154 1.15196C9.41443 1.26184 9.22503 1.58899 8.84622 2.24329Z",
    stroke: "#FFAB00",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordValidationIcon);
export default __webpack_public_path__ + "static/media/password_validation_icon.99daef423a5910dce205af6cdfcb02bd.svg";
export { ForwardRef as ReactComponent };